
export type GetModels200Item = {
  /** 사용 가능 여부 */
  available?: boolean;
  /** 모델 설명 */
  description?: string;
  /** 모델 ID */
  id?: string;
  /** 모델 이름 */
  name?: string;
  /** 제공자 */
  provider?: string;
};
